import React from 'react'
import Swiper from 'react-id-swiper'

import 'swiper/css/swiper.css'

const params = {
  slidesPerView: 1.1,
  spaceBetween: 10,
  centeredSlides: false,
  loop: true,
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
  breakpoints: {
    640: {
      slidesPerView: 1.2,
      centeredSlides: true,
      spaceBetween: 20,
    },
  },
}

const gallery = ({ images }) => (
  <div className="event-media media-gallery">
    <Swiper {...params}>
      {images?.map(image => (
        <div className="swiper-slide-container" key={image.source_url}>
          <img src={image.source_url} alt={image.title} />
        </div>
      ))}
    </Swiper>
  </div>
)

export default gallery
